import React from 'react';
export function ClosingWords() {
  return <section aria-labelledby="closing-heading" className="bg-wood-dark py-16 sm:py-24" data-id="element-38" data-mp="1tdgcp3rc2kif">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-39" data-mp="3mvcswkwp4vir">
        <p className="text-[10px] font-semibold uppercase tracking-label text-gold sm:text-[11px]" data-id="element-40" data-mp="3huyuzvot71yg">
          Final thoughts
        </p>
        <h2 id="closing-heading" className="mt-5 font-display text-3xl font-semibold leading-[1.06] text-gold-light sm:text-6xl" data-id="element-41" data-mp="3dtvhvgy5bk0x">
          Stop improvising. Start architecting.
        </h2>
        <p className="mt-7 text-sm leading-relaxed text-paper-300 sm:text-lg" data-id="element-42" data-mp="342ip8n4iwptu">
          You&rsquo;ve spent years mastering jazz guitar. You deserve a teaching system that matches
          your musicianship.
        </p>
        <p className="mt-4 text-sm leading-relaxed text-paper-300 sm:text-lg" data-id="element-43" data-mp="2q4avsp6p46nf">
          Join 2,500+ educators who now plan their entire year in less than five minutes.
        </p>
        <p className="mt-8 font-display text-xl italic text-gold sm:text-3xl" data-id="element-44" data-mp="2l7tz36lfkjyq">
          Stop the chaos. Start the system.
        </p>
      </div>
    </section>;
}